// Titre de page derive du pathname, affiche dans le Header (desktop + mobile).
// Couvre les alias FR/EN definis dans App.tsx.
const PAGE_TITLES: Record<string, string> = {
  '/': 'Tableau de bord',
  '/ames': 'Toutes les âmes',
  '/souls': 'Toutes les âmes',
  '/ames-indecises': 'Âmes indécises',
  '/undecided-souls': 'Âmes indécises',
  '/ames-evangelisees': 'Âmes évangélisées',
  '/evangelized-souls': 'Âmes évangélisées',
  '/interactions': 'Interactions',
  '/assigned-souls': 'Mes âmes suivies',
  '/ames-assignees': 'Mes âmes suivies',
  '/ma-famille/ames': 'Membres de ma famille',
  '/ma-famille/bergers': 'Bergers de ma famille',
  '/ma-famille/progression': 'Progression de ma famille',
  '/evangelisation/relances': 'À relancer',
  '/evangelisation/attendus': 'Attendus au culte',
  '/signalements-evangelistes': 'Signalements évangélistes',
  '/organisation': "Organisation de l'Église",
  '/presences': 'Présences',
  '/attendance': 'Présences',
  '/historique-presences': 'Historique des présences',
  '/statistiques': 'Statistiques',
  '/rappels': 'Rappels',
  '/rappels-bergers': 'Rappels des bergers',
  '/shepherd-reminders': 'Rappels des bergers',
  '/departements': 'Départements',
  '/serviteurs': 'B.O.S.S',
  '/familles': 'Familles de service',
  '/spiritual-progression': 'Progression spirituelle',
  '/bapteme': 'Suivi du baptême',
  '/birthdays': 'Anniversaires',
  '/anniversaires': 'Anniversaires',
  '/carte': 'Carte des âmes',
  '/soul-map': 'Carte des âmes',
  '/sms': 'SMS',
  '/modeles-sms': 'Modèles SMS',
  '/parametres': 'Paramètres',
  '/audio': 'Gestion audio',
  '/users': 'Utilisateurs',
  '/bug-reports': 'Signalements de bugs',
  '/churches': 'Gestion des Églises',
  '/replay': 'Replay des enseignements',
  '/cultes': 'Cultes : brief et débrief',
  '/plan-actions': "Plan d'actions",
  '/parametres-controle': 'Modèles de contrôle',
  '/academie': 'Académie',
  '/academie/gestion': 'Gestion Académie',
  '/academie/parametres': 'Paramètres Académie',
};

export function getPageTitle(pathname: string): string {
  // Cockpit d'un culte : /cultes/:eventId
  if (pathname.startsWith('/cultes/')) return 'Brief et débrief du culte';
  return PAGE_TITLES[pathname] ?? '';
}
